import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useIsMobile } from "@/hooks/hooks/use-mobile";
import { BaseNavigationBar, SettingsBackButton } from "@/lib/components/navigation";
import { PageContent } from "@/lib/components/page-content";
import { SettingsCategoryList } from "./components/settings-category-list";
import { SettingsSearchTrigger } from "./search/components/settings-search-trigger";

export function SettingsIndexPage() {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const { t } = useTranslation("settings");

  // Desktop has the sidebar nav, so /settings has no useful index — bounce to
  // the first concrete section so the page is never empty. Mobile uses
  // /settings as the categories drill-in target from /salon.
  useEffect(() => {
    if (!isMobile) {
      navigate("/settings/appearance", { replace: true });
    }
  }, [isMobile, navigate]);

  if (!isMobile) return null;

  return (
    <>
      <BaseNavigationBar
        title={t("settingsAndConfiguration", "Settings & Configuration")}
        backButton={<SettingsBackButton key="back-button" />}
        trailingElements={[<SettingsSearchTrigger key="search-trigger" />]}
      />
      <PageContent>
        <SettingsCategoryList />
      </PageContent>
    </>
  );
}
